var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-wrapper"},_vm._l((_vm.options),function(item){return _c('el-radio',{attrs:{"label":item.value}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }